import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "../context/auth";
import { Redirect } from "react-router-dom";
import { JWT, RESOLUTION_STATE_VALUES } from "../constants/local-storage";
import { CHANGE_LOGGED_IN } from "../constants/action-types";
import { store } from "../context/store.js";
import background from "../../images/background.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

export default function LogOut() {

  const { setAuthTokens } = useAuth();
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(function () {
    // Clear auth immediately
    setAuthTokens(null);
    localStorage.setItem(JWT, "null");
    localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify({}));
    dispatch({ type: CHANGE_LOGGED_IN, value: "" });

    // Small delay so UI renders nicely
    setTimeout(function () {
      setLoggedOut(true);
    }, 1200);
  }, []);

  if (loggedOut) {
    return <Redirect to="/" />;
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: "url(" + background + ")",
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >

      {/* Blur overlay */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.35)"
        }}
      />

      {/* Card */}
      <div
        style={{
          position: "relative",
          width: "360px",
          padding: "40px 30px",
          background: "#fff",
          borderRadius: "10px",
          boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
          textAlign: "center",
          zIndex: 10
        }}
      >
	  <h3 style={{ marginBottom: "12px", marginTop: "20px" }}>
	    You’ve been logged out
	  </h3>

        <div
          style={{
            fontSize: "14px",
            color: "#666",
            marginBottom: "28px"
          }}
        >
          Thanks for using OmniScan Pro.
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center"
          }}
        >
          <div
            onClick={function () {
              setLoggedOut(true);
            }}
            style={{
              height: "44px",
              padding: "0 28px",
              background: "#000",
              color: "#fff",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "bold"
            }}
          >
            Log back in
          </div>
        </div>
      </div>
	  {/* DIAMOND USER ICON */}
	  <div
	    style={{
	      position: "absolute",
	      top: "-35px",
	      left: "50%",
	      transform: "translateX(-50%) rotate(45deg)",
	      width: "70px",
	      height: "70px",
	      background: "linear-gradient(180deg, #4285F4 0%, #1E58B6 100%)",
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "center",
	      boxShadow: "0 6px 14px rgba(0,0,0,0.3)"
	    }}
	  >
	    <FontAwesomeIcon
	      icon={faUser}
	      style={{
	        color: "#fff",
	        fontSize: "28px",
	        transform: "rotate(-45deg)"
	      }}
	    />
	  </div>

    </div>
  );
}
